"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationTabNameForTelemetry = exports.PageName = exports.BASE_CLASS_NAME = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var classnames_1 = __importDefault(require("classnames"));
var SettingsDropdown_1 = __importDefault(require("./SettingsDropdown/SettingsDropdown"));
var qwilr_logo_dot_borderless_svg_1 = __importDefault(require("@ClientAssets/icons/qwilr-logo-dot-borderless.svg"));
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var DashboardUtils_1 = require("Dashboard/DashboardUtils");
exports.BASE_CLASS_NAME = "app-navigation";
var PageName;
(function (PageName) {
    PageName["Dashboard"] = "dashboard";
    PageName["Settings"] = "settings";
    PageName["Project"] = "project";
    PageName["Analytics"] = "analytics";
})(PageName || (exports.PageName = PageName = {}));
var Navigation = (function (_super) {
    __extends(Navigation, _super);
    function Navigation() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.getTooltipText = function () {
            if (_this.props.getLogoTooltip) {
                return _this.props.getLogoTooltip();
            }
            else if (!!(0, DashboardUtils_1.getSavedFolderId)()) {
                return "Back to page folder";
            }
            else {
                return "Back to pages dashboard";
            }
        };
        _this.onLogoClick = function (event) {
            var shouldOpenInNewTab = event.ctrlKey || event.metaKey;
            if (_this.props.onLogoClick) {
                _this.props.onLogoClick(shouldOpenInNewTab);
            }
            else if (shouldOpenInNewTab) {
                window.open("/#/pages", "_blank");
            }
            else {
                _this.props.$state.go("dashboard", { nav: "pages" });
            }
        };
        return _this;
    }
    Navigation.prototype.render = function () {
        return (react_1.default.createElement("section", { className: (0, classnames_1.default)(exports.BASE_CLASS_NAME, "".concat(exports.BASE_CLASS_NAME, "--new-nav"), "".concat(exports.BASE_CLASS_NAME, "--").concat(this.props.pageName)), onMouseDown: this.props.onMouseDown },
            this.renderIcon(),
            this.props.children,
            this.props.showSettings && (react_1.default.createElement(SettingsDropdown_1.default, { user: this.props.user, telemetry: this.props.telemetry, "$state": this.props.$state, openBrandSetup: this.props.openBrandSetup, publicApiBaseUrl: this.props.publicApiBaseUrl, rolesService: this.props.rolesService }))));
    };
    Navigation.prototype.renderIcon = function () {
        var showTooltip = this.props.pageName !== PageName.Dashboard;
        var text = this.getTooltipText();
        return (!this.props.hideLogo && (react_1.default.createElement(kaleidoscope_2.Tooltip, { show: showTooltip ? undefined : false, content: text, position: kaleidoscope_2.TooltipPosition.Bottom },
            react_1.default.createElement("button", { "data-testid": "home-button", className: "".concat(exports.BASE_CLASS_NAME, "__logo"), onClick: this.onLogoClick, onMouseUp: utils_1.handleMouseUpByBlurring, "aria-label": showTooltip ? undefined : text },
                react_1.default.createElement(kaleidoscope_1.SVG, { src: qwilr_logo_dot_borderless_svg_1.default })))));
    };
    Navigation.defaultProps = {
        showSettings: true,
    };
    Navigation = __decorate([
        mobx_react_1.observer
    ], Navigation);
    return Navigation;
}(react_1.default.Component));
exports.default = Navigation;
var NavigationTabNameForTelemetry;
(function (NavigationTabNameForTelemetry) {
    NavigationTabNameForTelemetry["Pages"] = "pages";
    NavigationTabNameForTelemetry["Blocks"] = "blocks";
    NavigationTabNameForTelemetry["Analytics"] = "analytics";
    NavigationTabNameForTelemetry["Reports"] = "reports";
})(NavigationTabNameForTelemetry || (exports.NavigationTabNameForTelemetry = NavigationTabNameForTelemetry = {}));
